module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-page"
  }, [_c('p', {
    staticClass: "page-title"
  }, [_vm._v("最新动态")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('v-card', [_c('el-tabs', {
    on: {
      "tab-click": function($event) {
        _vm.handleSearch()
      }
    },
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "全部",
      "name": "all"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "公司新闻",
      "name": "company"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "行业新闻",
      "name": "industry"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "媒体关注",
      "name": "media"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "newsListTopBlock"
  }), _vm._v(" "), _vm._l((_vm.NewsList), function(item) {
    return _c('div', {
      key: item.id
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'ArticleDetail',
          params: {
            id: item.id
          }
        }
      }
    }, [_c('el-row', {
      staticClass: "newsListRow",
      attrs: {
        "gutter": 22
      }
    }, [_c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('div', {
      staticClass: "textImgBox"
    }, [_c('img', {
      attrs: {
        "src": ("/static/images/" + (item.articleType) + ".jpg"),
        "width": "200",
        "height": "120"
      }
    })])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 16
      }
    }, [_c('span', {
      staticClass: "textTitle"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticClass: "textEllipsis",
      domProps: {
        "innerHTML": _vm._s(item.body)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "textFoot"
    }, [_vm._v("媒体来源：" + _vm._s(item.author))])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('div', {
      staticClass: "textDate"
    }, [_c('p', [_vm._v(_vm._s(_vm._f("NullDate")(_vm._f("date")(item.creationTime, 'MM-DD'))))]), _vm._v(" "), _c('span', {
      staticClass: "textArrow"
    }, [_c('i', {
      staticClass: "el-icon-arrow-right"
    })])])])], 1)], 1)], 1)
  }), _vm._v(" "), _c('el-pagination', {
    staticClass: "text-right",
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 2)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f765e6b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Articles/ArticleListPage.vue
// module id = 775
// module chunks = 0